module.exports = __webpack_public_path__ + "static/media/thumb.a65c7d41.jpg";